import { RootState, useAppSelector } from '../store/store'

export const useUser = () => {
    const user = useAppSelector((state: RootState) => state.auth.user)
    return user
}
